"use strict";
/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AddressMatchResponse$ = exports.AddressMatchResponse$outboundSchema = exports.AddressMatchResponse$inboundSchema = void 0;
exports.addressMatchResponseToJSON = addressMatchResponseToJSON;
exports.addressMatchResponseFromJSON = addressMatchResponseFromJSON;
const z = __importStar(require("zod"));
const schemas_js_1 = require("../../../lib/schemas.js");
const addressmatchwrapper_js_1 = require("./addressmatchwrapper.js");
/** @internal */
exports.AddressMatchResponse$inboundSchema = z.object({
    data: addressmatchwrapper_js_1.AddressMatchWrapper$inboundSchema,
});
/** @internal */
exports.AddressMatchResponse$outboundSchema = z.object({
    data: addressmatchwrapper_js_1.AddressMatchWrapper$outboundSchema,
});
/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
var AddressMatchResponse$;
(function (AddressMatchResponse$) {
    /** @deprecated use `AddressMatchResponse$inboundSchema` instead. */
    AddressMatchResponse$.inboundSchema = exports.AddressMatchResponse$inboundSchema;
    /** @deprecated use `AddressMatchResponse$outboundSchema` instead. */
    AddressMatchResponse$.outboundSchema = exports.AddressMatchResponse$outboundSchema;
})(AddressMatchResponse$ || (exports.AddressMatchResponse$ = AddressMatchResponse$ = {}));
function addressMatchResponseToJSON(addressMatchResponse) {
    return JSON.stringify(exports.AddressMatchResponse$outboundSchema.parse(addressMatchResponse));
}
function addressMatchResponseFromJSON(jsonString) {
    return (0, schemas_js_1.safeParse)(jsonString, (x) => exports.AddressMatchResponse$inboundSchema.parse(JSON.parse(x)), `Failed to parse 'AddressMatchResponse' from JSON`);
}
//# sourceMappingURL=addressmatchresponse.js.map